import { Calendar, CalendarDate, Location } from "@/components/icons";
import EarningsMetricCard from "@/features/founders/components/EarningsMetricCard";
import { formatCurrency } from "@/utils/currencies";

interface EarningsData {
  currentMonth: number;
  lastMonth: number;
  ytd: number;
}

interface EarningsOverviewProps {
  earnings: EarningsData;
  isLoading: boolean;
}

const EarningsOverview = ({ earnings, isLoading }: EarningsOverviewProps) => {
  // Calculate percentage change between current and last month
  const percentChange =
    earnings?.lastMonth > 0
      ? Math.round(
          ((earnings?.currentMonth - earnings?.lastMonth) /
            earnings?.lastMonth) *
            100
        )
      : 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <EarningsMetricCard
        title="This month"
        value={formatCurrency(earnings?.currentMonth)}
        isLoading={isLoading}
        icon={<Location className="h-[18px] w-[18px]" />}
      />

      <EarningsMetricCard
        title="Last month"
        value={formatCurrency(earnings?.lastMonth)}
        isLoading={isLoading}
        icon={<CalendarDate className="h-[18px] w-[18px]" />}
      />

      <EarningsMetricCard
        title="Year to date"
        value={formatCurrency(earnings?.ytd)}
        isLoading={isLoading}
        icon={<Calendar className="h-[18px] w-[18px]" />}
      />
    </div>
  );
};

export default EarningsOverview;
